import { handleAction } from 'redux-actions';
import { RefundMode } from '../../types';
import { toggle } from './actions';
const initialState = RefundMode.Auto;
export default handleAction(toggle, state => {
    return state === RefundMode.Auto ? RefundMode.Manual : RefundMode.Auto;
}, initialState);
